module.exports = __webpack_public_path__ + "img/index_part2img3.821ffd7c.jpg";